var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,on:{"click":function($event){return _vm.$emit('select', _vm.person.personId)}}},[_c('ovp-person-name',{staticClass:"tabs-tab__name",attrs:{"person":_vm.person}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }